import { create, StateCreator } from 'zustand';
import { PilotDoc, CoaDocument, DocType, CoaProject, DocsResponse } from '../types';
import { mapRawDocsToDocsState } from './documents_utils/mapRawDocsToDocsState';
import { devtools } from 'zustand/middleware';

type DocumentsState = {
  goodDocs: PilotDoc[];
  needAttentionDocs: PilotDoc[];
  missedDocTypes: DocType[];
  goodCoaDocs: CoaDocument[];
  needAttentionCoaDocs: CoaDocument[];
  coaProjects: CoaProject[];
};

type State = DocumentsState & {
  isInitialFetching: boolean;
};

type Actions = {
  setDocuments: (docsResponse: DocsResponse) => void;
  setIsInitialFetchingDone: () => void;

  computed: {
    hasNeedAttention: () => boolean;
  };
};

const initialState: State = {
  goodDocs: [],
  needAttentionDocs: [],
  missedDocTypes: [],
  goodCoaDocs: [],
  needAttentionCoaDocs: [],
  coaProjects: [],

  isInitialFetching: true,
};

const createDocumentsStore: StateCreator<State & Actions, [['zustand/devtools', never]], []> = (set, get) => ({
  ...initialState,

  setDocuments: (docsResponse) => set(() => mapRawDocsToDocsState(docsResponse)),
  setIsInitialFetchingDone: () => set(() => ({ isInitialFetching: false })),

  computed: {
    hasNeedAttention: () =>
      get().missedDocTypes.length + get().needAttentionDocs.length + get().needAttentionCoaDocs.length > 0,
  },
});

export const useDocumentsStore = create<State & Actions>()(
  devtools(createDocumentsStore, {
    name: 'DocumentsStore',
    enabled: !isProduction,
  }),
);
